import { FlexBox } from "@brg/ui";
import styled from "styled-components";
import { FC } from 'react';
import { useTranslation } from "react-i18next";
import { LegalsCloseWrapper } from "./styled";
import { IconCloseMob } from "../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal";
import {LayoutConst} from "../../../core";
import {SubmitModalShareButton} from "../ShareModal/styles";

const Wrapper = styled(FlexBox)`
  width: 576px;
  height: 277px;
  background: #FEFEFE;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  position: relative;
  padding: 48px 36px 36px 36px;
  flex-flow: column;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 36px 12px;
    width: 528px;
    height: 238px;
  }  
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    padding: 16px;
    width: 300px;
    height: 158px;
  }
`;

const Text = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #151514;

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: normal;
  }
`;

const Description = styled(FlexBox)`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #909090;
    padding-top: 24px;
  justify-content: center;

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    padding-top: 12px;
    letter-spacing: normal;
  }
`;

const ErrorCloseWrapper = styled(LegalsCloseWrapper)`
  @media (max-width: ${LayoutConst.screen.m}px) {
    top: 16px;
    right: 16px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    top: -35px;
    right: 0px;
  }
`

export const ErrorModal: FC<{ onClick: () => void, onClose: () => void }> = ({ onClick, onClose }) => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <ErrorCloseWrapper onClick={onClose}><IconCloseMob /></ErrorCloseWrapper>
            <Text>
                {t('project_edit.modal.error.title')}
            </Text>
            <Description>{t('project_edit.modal.error.description_first')}<br/>{t('project_edit.modal.error.description_second')}</Description>
            <FlexBox align={'center'} alignMobile={'center'} justify={'center'} offsetTop={24} offsetTopMobile={12}>
                <SubmitModalShareButton onClick={onClick}>{t('project_edit.modal.error.try')}</SubmitModalShareButton>
            </FlexBox>
        </Wrapper>
    )
}import { FlexBox } from "@brg/ui";
import styled from "styled-components";
import { FC } from 'react';
import { useTranslation } from "react-i18next";
import { LegalsCloseWrapper } from "./styled";
import { IconCloseMob } from "../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal";
import {LayoutConst} from "../../../core";
import {SubmitModalShareButton} from "../ShareModal/styles";

const Wrapper = styled(FlexBox)`
  width: 576px;
  height: 277px;
  background: #FEFEFE;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  position: relative;
  padding: 48px 36px 36px 36px;
  flex-flow: column;
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 36px 12px;
    width: 528px;
    height: 238px;
  }  
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    padding: 16px;
    width: 300px;
    height: 158px;
  }
`;

const Text = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #151514;

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: normal;
  }
`;

const Description = styled(FlexBox)`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #909090;
    padding-top: 24px;
  justify-content: center;

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    padding-top: 12px;
    letter-spacing: normal;
  }
`;

const ErrorCloseWrapper = styled(LegalsCloseWrapper)`
  @media (max-width: ${LayoutConst.screen.m}px) {
    top: 16px;
    right: 16px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    top: -35px;
    right: 0px;
  }
`

export const ErrorModal: FC<{ onClick: () => void, onClose: () => void }> = ({ onClick, onClose }) => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <ErrorCloseWrapper onClick={onClose}><IconCloseMob /></ErrorCloseWrapper>
            <Text>
                {t('project_edit.modal.error.title')}
            </Text>
            <Description>{t('project_edit.modal.error.description_first')}<br/>{t('project_edit.modal.error.description_second')}</Description>
            <FlexBox align={'center'} alignMobile={'center'} justify={'center'} offsetTop={24} offsetTopMobile={12}>
                <SubmitModalShareButton onClick={onClick}>{t('project_edit.modal.error.try')}</SubmitModalShareButton>
            </FlexBox>
        </Wrapper>
    )
}